import Phaser from "phaser";
import { footprintSpan, placedShapeLayout } from "../data/modulePorts.js";
import { drawCellPorts } from "./shapeRenderer.js";
import type { RewardShape } from "../systems/rewardLineItems.js";

/**
 * 보상 모달 셀의 모듈 조각 모양 아이콘 — 획일 아이콘(image) 대신 실제 인스턴스 파이프 모양을 그린다.
 * 도감/모듈 정보팝업(ModuleInfoPopup.rebuildPoolRow)과 동일한 패턴: footprint span으로 boxPx 안에
 * 맞도록 셀 크기를 보정한 뒤 placedShapeLayout(SSoT) → drawCellPorts(발광 레일+구슬).
 *
 * @param scene Graphics를 생성할 Phaser.Scene.
 * @param x Graphics 중심 x (scene 좌표계).
 * @param y Graphics 중심 y (scene 좌표계).
 * @param boxPx 아이콘 정사각 박스 한 변(px) — 2칸 조각도 이 안에 들어가도록 셀 크기를 자동 축소.
 * @param shape 그릴 조각의 shapeId/footprintId.
 * @param color 레일·구슬 틴트 (Phaser color number, 보통 등급색).
 * @returns 생성된 Graphics — caller가 컨테이너 추가/정리 목록 등록.
 */
export function drawRewardShapeIcon(
  scene: Phaser.Scene,
  x: number,
  y: number,
  boxPx: number,
  shape: RewardShape,
  color: number,
): Phaser.GameObjects.Graphics {
  const span = footprintSpan(shape.footprintId);
  const cellPx = boxPx / Math.max(span.spanX, span.spanY);
  const { segs, half } = placedShapeLayout(shape.shapeId, shape.footprintId, cellPx, cellPx >= 24 ? 4 : 2);
  const g = scene.add.graphics();
  g.setPosition(x, y);
  drawCellPorts(g, segs, half, color, 1);
  return g;
}
